import { useMutation, useQueryClient } from '@tanstack/react-query';
import { Permission } from '../../domain/permissions';
import { useAuthentication } from '../../modules/auth/AuthenticationProvider';
import { BACKEND_URL } from '../backend-url';

type CreateGroupData = {
    name: string;
    description: string;
    permissions: Permission[];
}

export const useCreateGroupRepository = () => {
    const { getJwtToken } = useAuthentication();
    const queryClient = useQueryClient();

    const mutation = useMutation({
        mutationFn: async (data: CreateGroupData) => {
            const token = await getJwtToken();

            const response = await fetch(`${BACKEND_URL}/groups`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify(data),
            });

            if (!response.ok) {
                throw new Error('Failed to create group');
            }

            return await response.json();
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['groups'] });
        },
    });

    return {
        createGroup: mutation.mutateAsync,
        ...mutation,
    };
};
